/**
 * @module ラベル部共通コンポーネント
 */
export default {
  name: 'Label',
  data() {
    return {};
  },
  props: {
    label: String,
  },
};
